/*
 * @Author: your name
 * @Date: 2021-04-13 20:44:52
 * @LastEditTime: 2021-06-21 23:17:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\api\basicAPI.js
 */
import axios from 'axios';
import { ServerPath } from '@/config/serverPath';

/**
 * @name: 获取头部商品列表信息和产品分类信息，子列表信息
 * @msg: 无
 * @return {*}
 */
export async function basic_info() {
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/data_select/basic_info.html`,
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}

/**
 * @name: 获取头部商品列表信息和产品分类信息，子列表信息
 * @msg: 无
 * @return {*}
 */
 export async function filter_info(list_id, classify_id, brand_id) {
    var resp = null;
    await axios({
        method: 'GET',
        url: `${ServerPath}/api/data_select/filter_info.html`,
        params: {
            list_id: list_id,
            classify_id: classify_id,
            brand_id: brand_id
        }
    }).then(res => {
        resp = res.data;
    }).catch(req => {
        console.log(req);
    });

    return resp;
}